export default __webpack_public_path__ + "static/media/logo.40d6e83f.png";